module.exports = __webpack_public_path__ + "static/webpack-comment-7a22af8d379cfe591ca5ad36856afa25.jpg";